import clone from 'lodash/cloneDeep';
import initialState from '../../../store/initialState';
import {
  UPDATE_MEMBER_STARTING,
  UPDATE_MEMBER_SUCCESS,
  UPDATE_MEMBER_ERROR,
} from '../../../constants/actionTypes';

export default function updateMemberReducer(state = initialState.updateMember, action) {
  switch (action.type) {
    case UPDATE_MEMBER_STARTING: {

      const { memberId } = action;
      const newState = clone(state);

      if (!newState[memberId]) {
        newState[memberId] = clone(initialState.updateMember.memberId);
      }

      const updateData = newState[memberId];
      updateData.saving = true;
      updateData.saved = false;
      updateData.error = null;
       
      return newState;
    }

    case UPDATE_MEMBER_SUCCESS: {
      const { memberId } = action;

      const newState = clone(state);

      if (!newState[memberId]) {
        newState[memberId] = clone(initialState.updateMember.memberId);
      }
      const updateData = newState[memberId];

      updateData.saving = false;
      updateData.saved = true;
      updateData.error = null;
      
      return newState;
    }

    case UPDATE_MEMBER_ERROR: {
      const { memberId } = action;

      const newState = clone(state);

      if (!newState[memberId]) {
        newState[memberId] = clone(initialState.updateMember.memberId);
      }
      const updateData = newState[memberId];
      updateData.saving = false;
      updateData.saved = false;
      updateData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
